function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

// if(getParameterByName('edit')) {
//   localStorage.setItem('variants', getParameterByName('variants'));
//   localStorage.setItem('message', getParameterByName('message'));
// }

class CustomBox extends HTMLElement {
  constructor() {
    super();
    
    this.handle = this.dataset.handle;
    this.cardIndex = 0;
    this.stepLoadPromises = {};
    this.stepApiCache = {};
    this.iconPlus = document.getElementById('icon-plus-2')?.innerHTML || '';
    this.iconCheck = document.getElementById('icon-check')?.innerHTML || '';
    this.iconQuickView = document.getElementById('icon-quick-view')?.innerHTML || '';
    this.iconChevron = document.getElementById('icon-chevron')?.innerHTML || '';
    // header
    this.header = this.querySelector('.custom-box__header');
    this.headerImage = this.header.querySelector('img');
    this.headerTitle = this.header.querySelector('.header__title');
    this.headerSubtitle = this.header.querySelector('.header__subtitle');

    // Steps
    this.stepsLi = this.querySelectorAll('.custom-box__steps ul li');
    this.stepTitle = this.querySelector('.custom-box__step-title');
    this.step1Container = this.querySelector('.custom-box__step-1');
    this.step1Grid = this.step1Container.querySelector('.custom-box__step-1 .grid');
    this.step2Container = this.querySelector('.custom-box__step-2');
    this.step3Container = this.querySelector('.custom-box__step-3');
    this.step3Grid = this.step3Container.querySelector('.grid');
    this.step4Container = this.querySelector('.custom-box__step-4');
    this.step4Grid = this.step4Container.querySelector('.grid');
    this.step5Container = this.querySelector('.custom-box__step-5');

    // Messages
    this.messageField = this.querySelector('#cmMsgInput');
    this.messages = this.querySelectorAll('.predefined-messages input[type="radio"]');    

    this.messageField.addEventListener('keyup', function(){
      this.handleMessageCharacters();      
    }.bind(this));

    // Load step 1 immediately; cascade later steps after each completes
    // so they do not compete for network bandwidth.
    this.ensureStepLoaded(1).then(() => {
      this.ensureStepLoaded(2);
      // Edit mode needs all steps available for pre-selection.
      if (getParameterByName('edit')) {
        this.ensureStepLoaded(3);
        this.ensureStepLoaded(4);
      }
    });

    this.step1Container.querySelector('.custom-box__nav-next').addEventListener('click', function(e){
      e.preventDefault();
      this.ensureStepLoaded(2);
      this.step1Container.classList.add('hidden');
      this.step2Container.classList.remove('hidden');
      this.stepsLi[1].classList.add('active');
      this.setAttribute('data-current-step', 2);
      this.stepTitle.textContent = this.step2Container.dataset.subtitle;
      this.scrollToTop();
      requestAnimationFrame(() => this.observeLazyImages(this.step2Container));
    }.bind(this));

    this.step2Container.querySelector('.custom-box__nav-next').addEventListener('click', function(e){
      e.preventDefault();
      this.ensureStepLoaded(3);
      this.step2Container.classList.add('hidden');
      this.step3Container.classList.remove('hidden');
      this.stepsLi[2].classList.add('active');
      this.setAttribute('data-current-step', 3);
      this.stepTitle.textContent = this.step3Container.dataset.subtitle;
      this.scrollToTop();
      requestAnimationFrame(() => this.observeLazyImages(this.step3Container));
    }.bind(this));

    this.step3Container.querySelector('.custom-box__nav-next').addEventListener('click', function(e){
      e.preventDefault();
      this.ensureStepLoaded(4);
      this.step3Container.classList.add('hidden');
      this.step4Container.classList.remove('hidden');
      this.stepsLi[3].classList.add('active');
      this.setAttribute('data-current-step', 4);
      this.stepTitle.textContent = this.step4Container.dataset.subtitle;
      this.scrollToTop();
      requestAnimationFrame(() => this.observeLazyImages(this.step4Container));
    }.bind(this));

    this.step4Container.querySelector('.custom-box__nav-next').addEventListener('click', function(e){
      e.preventDefault();
      this.step4Container.classList.add('hidden');
      this.step5Container.classList.remove('hidden');
      // this.stepsLi[4].classList.add('active');
      this.setAttribute('data-current-step', 5);
      this.scrollToTop();
    }.bind(this));

    this.step2Container.querySelector('.custom-box__nav-prev').addEventListener('click', function(e){
      e.preventDefault();
      this.step1Container.classList.remove('hidden');
      this.step2Container.classList.add('hidden');
      this.stepsLi[1].classList.remove('active');
      this.setAttribute('data-current-step', 1);
      this.stepTitle.textContent = this.step1Container.dataset.subtitle;
      this.scrollToTop();
    }.bind(this));

    this.step3Container.querySelector('.custom-box__nav-prev').addEventListener('click', function(e){
      e.preventDefault();
      this.step2Container.classList.remove('hidden');
      this.step3Container.classList.add('hidden');
      this.stepsLi[2].classList.remove('active');
      this.setAttribute('data-current-step', 2);
      this.stepTitle.textContent = this.step2Container.dataset.subtitle;
      this.scrollToTop();
      requestAnimationFrame(() => this.observeLazyImages(this.step2Container));
    }.bind(this));

    this.step4Container.querySelector('.custom-box__nav-prev').addEventListener('click', function(e){
      e.preventDefault();
      this.step3Container.classList.remove('hidden');
      this.step4Container.classList.add('hidden');
      this.stepsLi[3].classList.remove('active');
      this.setAttribute('data-current-step', 3);
      this.stepTitle.textContent = this.step3Container.dataset.subtitle;
      this.scrollToTop();
      requestAnimationFrame(() => this.observeLazyImages(this.step3Container));
    }.bind(this));

    this.step5Container.querySelector('.custom-box__nav-prev').addEventListener('click', function(e){
      e.preventDefault();
      this.step4Container.classList.remove('hidden');
      this.step5Container.classList.add('hidden');
      this.setAttribute('data-current-step', 4);
      this.stepTitle.textContent = this.step4Container.dataset.subtitle;
      this.scrollToTop();
    }.bind(this));

    this.querySelector('.custom-box__nav-atc').addEventListener('click', function(){
      if(getParameterByName('ts')) {
        document.body.classList.add('data-loading');
        let formData = {updates: {}};
        document.querySelectorAll('.cart-item[data-item-ts="'+ getParameterByName('ts') +'"]').forEach(function(el, index){
          formData.updates[el.getAttribute('id').replace('cart-notification-product-', '')] = 0;
        });
        const updatePromise = window.CartFetch
          ? (window.CartFetch.invalidate(), window.CartFetch.post('/cart/update.js', formData))
          : fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(formData) }).then(r => r.text());

        updatePromise
          .then(() => {
            this.createBox();
          }).catch((e) => {
            // Error handled silently
          });
      } else {
        this.createBox();
      }      
    }.bind(this));

    this.addEventListener('click', function(e){
      let el = e.target;
      if(el.closest('summary') !== null) {
        e.preventDefault();
        let details = el.closest('details');
        if(details.open) {
          details.removeAttribute('open')
        } else {
          details.setAttribute('open', true);
        }        
      }else if(el.name === 'preselected_message') {
        this.changeEvent(el);
      }else if(el.classList.contains('quick__view')) {   
        e.preventDefault();     
        document.body.classList.add('no-overflow');
        let parent = el.closest('.custom-box__card');
        this.hydrateQuickViewImage(parent);
        parent.querySelector('.custom-box__quick-view .quantity__input').value = parent.querySelector('input[type="checkbox"]').dataset.quantity;
        parent.querySelector('.custom-box__quick-view').classList.remove('hidden');
      }else if(el.classList.contains('qv__button')) {
        let parent = el.closest('.custom-box__card');
        let inputSelector = parent.querySelector('input[type="checkbox"]');
        inputSelector.setAttribute('data-quantity', parent.querySelector('input.quantity__input').value);
        inputSelector.checked = true;
        this.changeEvent(inputSelector);
        parent.querySelector('.custom-box__quick-view').classList.add('hidden');
        document.body.classList.remove('no-overflow');
      }else if(el.classList.contains('qv__close')) {
        let parent = el.closest('.custom-box__card');
        parent.querySelector('.custom-box__quick-view').classList.add('hidden');
        document.body.classList.remove('no-overflow');
      }else if(el.closest('.custom-box__quick-view') !== null){
      }else if(el.closest('.custom-box__card') !== null) {
        let card = el.closest('.custom-box__card');
        card.classList.toggle('selected');
        if(!card.querySelector('input').checked) {
          card.querySelector('input').checked = true;  
        } else {
          card.querySelector('input').checked = false; 
        }
        this.changeEvent(card.querySelector('input'));   
      }
    })
  }

  fetchStepApi(step) {
    if (this.stepApiCache[step]) return this.stepApiCache[step];

    this.stepApiCache[step] = fetch(
      `https://poojastore.mobikasa.net/api/get/get_box/${this.handle}/step${step}`
    )
      .then((response) => {
        if (!response.ok) throw new Error(`Failed to load step ${step}`);
        return response.json();
      })
      .catch((error) => {
        delete this.stepApiCache[step];
        throw error;
      });

    return this.stepApiCache[step];
  }

  ensureStepLoaded(step) {
    if (this.stepLoadPromises[step]) return this.stepLoadPromises[step];

    const loaders = {
      1: () => this.renderStep1Content(this.handle),
      2: () => this.renderStep2Content(this.handle),
      3: () => this.renderStep3Content(this.handle),
      4: () => this.renderStep4Content(this.handle)
    };

    if (!loaders[step]) return Promise.resolve();

    this.stepLoadPromises[step] = Promise.resolve()
      .then(() => loaders[step]())
      .then(() => {
        // Prefetch the next step once the current one is ready.
        if (step >= 2 && step < 4 && !getParameterByName('edit')) {
          this.ensureStepLoaded(step + 1);
        }
      })
      .catch((error) => {
        delete this.stepLoadPromises[step];
        throw error;
      });

    return this.stepLoadPromises[step];
  }

  scrollToTop() {
    window.scrollTo({
      top: document.querySelector('custom-box').offsetTop,
      left: 0
    })
  }

  changeEvent(el) {
    if(el.type === 'checkbox'){
      let parent = el.closest(".custom-box__step");
      let allEls = parent.querySelectorAll(".custom-box__card input[type='checkbox']");
      let next = parent.querySelector(".custom-box__nav-next");
      let prev = parent.querySelector(".custom-box__nav-prev");
      let minLimit = parseInt(parent.dataset.minQty);
      let maxLimit = parseInt(parent.dataset.maxQty);

      if(parent.querySelectorAll("input[type='checkbox']:checked").length === maxLimit) {
        allEls.forEach((input, index) => {
          if(!input.checked) {
            input.closest(".custom-box__card").classList.add('disabled');
          }
        });          
      } else {
        allEls.forEach((input, index) => {
          input.closest(".custom-box__card").classList.remove('disabled');
        });          
      }

      if(next) {
        if(parent.querySelectorAll("input[type='checkbox']:checked").length >= minLimit) {
          next.classList.remove('disabled');
        } else {
          next.classList.add('disabled');
        }
      }
    }

    // Selecting a pre-written message
    if(el.name === 'preselected_message') {
      this.messageField.value = el.value;
      el.closest('details').removeAttribute('open');
      this.handleMessageCharacters();
    }
  }

  editBoxActions(parent) {
    if(getParameterByName('edit')) {
      let variants = JSON.parse(getParameterByName('variants'));
      let quantities = JSON.parse(getParameterByName('quantity'));
      let message = JSON.parse(getParameterByName('message'));
      let details = JSON.parse(getParameterByName('details'));
      variants.forEach((element, i) => {
        let parentContainer = document.querySelector(`[data-collection-title="${details[i].title.trim()}"]`);
        if(!parentContainer) return;
        let targetEl = parentContainer.querySelector('input[type="checkbox"][value="'+ element +'"]');    
        if(targetEl) {
          targetEl.checked = true;
          targetEl.dataset.quantity = quantities[i];
          this.changeEvent(targetEl);
        }
      });

      if(message) {
        document.getElementById('recipientInput').value = message['To'];
        document.getElementById('userNameInput').value = message['From'];
        document.getElementById('cmMsgInput').value = message['Message'];
      }
      // window.history.pushState({}, document.title, location.origin + location.pathname);
    }    
  }

  handleMessageCharacters() {
    let limit = 300;
    let length = this.messageField.value.length;
    
    if((limit - length) <= 0) {
      document.querySelector('#characters').style.color = "red";
      document.querySelector('#characters span').textContent = 0;
    }else {
      document.querySelector('#characters').removeAttribute('style');
      document.querySelector('#characters span').textContent = limit - length;
    }
  }

  escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // Use Mobikasa get_box product payloads directly.
  // They already include variant_id / price / image / title, so we must not
  // fan out to /products/{handle}.js (200+ requests on Step 2).
  normalizeApiProducts(products) {
    if (!Array.isArray(products) || !products.length) return [];

    const normalized = [];
    const seenVariantIds = new Set();

    for (const product of products) {
      if (!product?.variant_id) continue;
      const variantKey = String(product.variant_id);
      if (seenVariantIds.has(variantKey)) continue;
      seenVariantIds.add(variantKey);
      normalized.push(product);
    }

    return normalized;
  }

  // Request a small CDN derivative. Old `_180x.jpg` replace missed `.webp`
  // and loaded full originals (often 200–400KB each).
  getSizedImageUrl(src, width) {
    if (!src) return '';
    try {
      const url = new URL(src, window.location.href);
      url.pathname = url.pathname.replace(/_(\d+x\d*|\d*x\d+)(?=\.[a-zA-Z0-9]+$)/, '');
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (e) {
      return src;
    }
  }

  hydrateQuickViewImage(card) {
    const wrap = card?.querySelector('.qv__image-wrap');
    if (!wrap || wrap.querySelector('img')) return;

    const img = document.createElement('img');
    img.src = this.getSizedImageUrl(wrap.dataset.largeSrc || '', 600);
    img.alt = wrap.dataset.alt || '';
    img.width = 600;
    img.height = 600;
    img.decoding = 'async';
    wrap.appendChild(img);
  }

  initLazyImageObserver() {
    if (this.lazyImageObserver) return;

    this.lazyImageObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const img = entry.target;
        const src = img.dataset.src;
        if (src) img.src = src;
        img.removeAttribute('data-src');
        this.lazyImageObserver.unobserve(img);
      });
    }, {
      root: null,
      rootMargin: '120px 0px',
      threshold: 0.01
    });
  }

  observeLazyImages(root = this) {
    this.initLazyImageObserver();
    root.querySelectorAll('img.custom-box__thumb[data-src]').forEach((img) => {
      this.lazyImageObserver.observe(img);
    });
  }

  appendProductCards(grid, products, type) {
    const fragment = document.createDocumentFragment();
    for (let i = 0; i < products.length; i++) {
      fragment.append(this.renderProductCard(products[i], type));
    }
    grid.append(fragment);
    this.observeLazyImages(grid);
  }

  renderCollectionProducts(container, products, type) {
    if (container.dataset.productsRendered === 'true' || container.dataset.productsRendering === 'true') {
      return;
    }
    container.dataset.productsRendering = 'true';

    try {
      const grid = container.querySelector('.grid');
      if (!grid) return;

      const expanded = this.normalizeApiProducts(products || []);
      this.appendProductCards(grid, expanded, type);
      container.dataset.productsRendered = 'true';
      this.editBoxActions(container);
    } finally {
      delete container.dataset.productsRendering;
    }
  }

  // Only mount product cards when the collection is near the viewport,
  // so Step 2 does not insert hundreds of image nodes at once.
  scheduleCollectionProducts(container, products, type, options = {}) {
    const { immediate = false } = options;
    if (immediate || getParameterByName('edit')) {
      this.renderCollectionProducts(container, products, type);
      return;
    }

    if (container.dataset.productsScheduled === 'true') return;
    container.dataset.productsScheduled = 'true';

    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      this.renderCollectionProducts(container, products, type);
    }, {
      root: null,
      rootMargin: '200px 0px',
      threshold: 0.01
    });

    observer.observe(container);
  }

  renderProductCard(data, type){
    const cardIndex = this.cardIndex++;
    const title = this.escapeHtml(data.tittle);
    const handle = this.escapeHtml(data.handle);
    const src = data.src || '';
    const thumbSrc = this.getSizedImageUrl(src, 180);
    const largeSrc = this.escapeHtml(src);
    let li = document.createElement('li');
    li.innerHTML = `<input type="checkbox" name="${type}" value="${data.variant_id}" tabindex="${cardIndex}" data-quantity="1" id="item-${data.variant_id}-${type}-${cardIndex}" data-product-price="${data.product_price}" data-product-title="${title}" />
    <label for="item-${data.variant_id}-${type}-${cardIndex}">
      <div class="icons">
        ${this.iconPlus}
        ${this.iconCheck}
      </div>            
      <div class="media" style="padding-bottom: 100%;">
        <img class="custom-box__thumb" data-src="${thumbSrc}" alt="${title}" decoding="async" width="180" height="180" />
        <div class="price ${data.product_price <= 0 ? 'hidden' : ''}">₹${data.product_price}</div>
      </div>
      <div class="content">
        <h4>${title}</h4>
        <a href="/products/${handle}" class="quick__view ${data.product_price <= 0 ? 'hidden' : ''}">${this.iconQuickView}</a>     
      </div>      
    </label>
    <div class="custom-box__quick-view hidden">
    <span class="qv__close qv__overlay"></span><div class="qv__grid">
      <span class="qv__close qv__close-icon"></span>
      <div class="qv__grid-item qv__image-wrap" data-large-src="${largeSrc}" data-alt="${title}"></div>
      <div class="qv__grid-item">
        <product-title>${title}</product-title>
        <div class="qv__qty">
          <label>Quantity</label>
          <quantity-input class="quantity">
            <button class="quantity__button no-js-hidden" name="minus" type="button">                
              -
            </button>
            <input class="quantity__input"
                type="number"
                name="quantity"
                min="1"
                value="1"
              >
            <button class="quantity__button no-js-hidden" name="plus" type="button">
              +
            </button>
          </quantity-input>
        </div>
        <button class="button button--primary qv__button">Add To Cart</button>
      </div>
      </div>
    </div>
    `
    li.setAttribute('data-product-handle', data.handle);
    li.setAttribute('data-product-sku', data.sku);
    li.setAttribute('data-variant-id', data.variant_id);
    li.classList.add('grid__item', 'custom-box__card');
    if (typeof data.tags === 'string' && data.tags.includes('product-delhi')) {
      li.classList.add('hide-unless-delhi');
    }
    return li;
  }

  renderStep1Content(handle) {
    return this.fetchStepApi(1)
      .then(async (data) => {
        const d = data.data;
        // Warm Step 2 API while Step 1 products expand (JSON only, no variant fetches).
        this.fetchStepApi(2);
        const products = this.normalizeApiProducts(d[0][0].products);
        let thisParentContainer = this.step1Container;

        this.headerImage.src = d.banner_image;
        this.headerTitle.textContent = d.box_subtitle;
        this.headerSubtitle.textContent = d.box_title;     
        
        document.querySelector('[name="properties[_topTitle]"]').value = d.box_title;

        this.stepTitle.textContent = d.collection_subtitle;
        thisParentContainer.setAttribute('data-subtitle', d.collection_subtitle);
        thisParentContainer.setAttribute('data-min-qty', d.min_qty);
        thisParentContainer.setAttribute('data-max-qty', d.max_qty);

        // enable Next button is the minimum quanity is 0 i.e Skip option
        if(d.min_qty === 0) {
          thisParentContainer.querySelector('.custom-box__nav-next').classList.remove('disabled');
        }

        // build predefined messages
        const messageFragment = document.createDocumentFragment();
        for(var i=0;i<d.custom_message.length;i++) {
          let message = document.createElement('li');
          message.innerHTML = `<input type="radio" value="${d.custom_message[i]}" name="preselected_message" id="key-${i}" /><label for="key-${i}">${d.custom_message[i]}</label>`;
          messageFragment.append(message);
        }
        document.querySelector('.predefined-messages ul').append(messageFragment);

        // build step 1 grid
        this.step1Grid.setAttribute('data-collection-title', d[0][0].collection_name);
        this.appendProductCards(this.step1Grid, products, 'collection-1');
        
        thisParentContainer.classList.add('content-loaded');
        this.editBoxActions(thisParentContainer);
      });
  }

  renderStep2Content(handle) {
    let thisParentContainer = this.step2Container;
    if(thisParentContainer.classList.contains('content-loaded')) {return Promise.resolve();}
    return this.fetchStepApi(2)
      .then(async (data) => {
        const d = data.data;
        const collections = d[0];
        const isEditMode = !!getParameterByName('edit');

        thisParentContainer.setAttribute('data-subtitle', d.collection_subtitle);   
        thisParentContainer.setAttribute('data-min-qty', d.min_qty);
        thisParentContainer.setAttribute('data-max-qty', d.max_qty);
        if (this.getAttribute('data-current-step') === '2') {
          this.stepTitle.textContent = d.collection_subtitle;
        }

        // enable Next button is the minimum quanity is 0 i.e Skip option
        if(d.min_qty === 0) {
          thisParentContainer.querySelector('.custom-box__nav-next').classList.remove('disabled');
        }

        // Warm Step 3 API while Step 2 UI is built.
        this.fetchStepApi(3);

        // Build collection shells first so the loader can clear immediately.
        const collectionsFragment = document.createDocumentFragment();
        const scheduledMounts = [];

        for (var i = 0; i < collections.length; i++) {
          const collection = collections[i];
          const div = document.createElement('div');
          div.classList.add('collection__list');

          const startOpen = collections.length === 1 || collection.collection_image === '' || isEditMode;

          if (collections.length > 1) {
            div.innerHTML = `<details ${startOpen ? 'open' : ''}>
              <summary ${collection.collection_image === '' ? 'hidden' : ''}>
                <img src="${collection.collection_image}" alt="${collection.collection_name}" />
                <h3>
                  ${collection.collection_name}
                  ${this.iconChevron}
                </h3>
              </summary>
              <ul class="grid grid--2-col grid--4-col-tablet grid--6-col-desktop" data-collection-title="${collection.collection_name}"></ul>
            </details>`;

            const details = div.querySelector('details');
            details.addEventListener('toggle', () => {
              if (details.open) {
                this.scheduleCollectionProducts(div, collection.products, 'collection-2', { immediate: true });
              }
            });
          } else {
            div.innerHTML = `<ul class="grid grid--2-col grid--4-col-tablet grid--6-col-desktop" data-collection-title="${collection.collection_name}"></ul>`;
          }

          collectionsFragment.append(div);

          if (startOpen) {
            scheduledMounts.push({
              container: div,
              products: collection.products,
              immediate: isEditMode || i === 0
            });
          }
        }

        thisParentContainer.append(collectionsFragment);
        thisParentContainer.classList.add('content-loaded');

        // Schedule after attach so IntersectionObserver can see real layout.
        scheduledMounts.forEach((mount) => {
          this.scheduleCollectionProducts(mount.container, mount.products, 'collection-2', {
            immediate: mount.immediate
          });
        });
        requestAnimationFrame(() => this.observeLazyImages(thisParentContainer));
      });
  }

  renderStep3Content(handle) {
    let thisParentContainer = this.step3Container;
    if(thisParentContainer.classList.contains('content-loaded')) {return Promise.resolve();}
    return this.fetchStepApi(3)
      .then(async (data) => {
        const d = data.data;
        this.fetchStepApi(4);
        const products = this.normalizeApiProducts(d[0][0].products);        

        thisParentContainer.setAttribute('data-subtitle', d.collection_subtitle);
        thisParentContainer.setAttribute('data-min-qty', d.min_qty);
        thisParentContainer.setAttribute('data-max-qty', d.max_qty);
        if (this.getAttribute('data-current-step') === '3') {
          this.stepTitle.textContent = d.collection_subtitle;
        }

        // enable Next button is the minimum quanity is 0 i.e Skip option
        if(d.min_qty === 0) {
          thisParentContainer.querySelector('.custom-box__nav-next').classList.remove('disabled');
        }

        // build step 3 grid
        this.step3Grid.setAttribute('data-collection-title', d[0][0].collection_name);
        this.appendProductCards(this.step3Grid, products, 'collection-3');
        thisParentContainer.classList.add('content-loaded');
        this.editBoxActions(thisParentContainer);
      });
  }

  renderStep4Content(handle) {
    let thisParentContainer = this.step4Container;
    if(thisParentContainer.classList.contains('content-loaded')) {return Promise.resolve();}
    return this.fetchStepApi(4)
      .then(async (data) => {
        const d = data.data;
        const products = this.normalizeApiProducts(d[0][0].products);        

        thisParentContainer.setAttribute('data-subtitle', d.collection_subtitle);
        thisParentContainer.setAttribute('data-min-qty', d.min_qty);
        thisParentContainer.setAttribute('data-max-qty', d.max_qty);
        if (this.getAttribute('data-current-step') === '4') {
          this.stepTitle.textContent = d.collection_subtitle;
        }

        // enable Next button is the minimum quanity is 0 i.e Skip option
        if(d.min_qty === 0) {          
          thisParentContainer.querySelector('.custom-box__nav-next').classList.remove('disabled');
        }

        // build step 4 grid
        this.step4Grid.setAttribute('data-collection-title', d[0][0].collection_name);
        this.appendProductCards(this.step4Grid, products, 'collection-4');
        thisParentContainer.classList.add('content-loaded');
        this.editBoxActions(thisParentContainer);
      });
  }

  createBox() {    
    document.body.classList.add('data-loading');
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    let formData = {'items': []};
    let totalPrice = 0;
    let variants = [];
    let quantity = [];
    let productDetails = [];
    let timestamp = (new Date().getTime());
    let message = {
      To: document.getElementById('recipientInput').value.toUpperCase(),
      From: document.getElementById('userNameInput').value.toUpperCase(),
      Message: document.getElementById('cmMsgInput').value
    }

    this.querySelectorAll('.custom-box__card input:checked').forEach((el, index) => {
      variants.push(el.value);
      quantity.push(el.dataset.quantity);
      totalPrice += (parseInt(el.dataset.productPrice)*el.dataset.quantity);
      if(el.closest('ul.grid').dataset.collectionTitle) {
        productDetails.push({
          title: el.closest('ul.grid').dataset.collectionTitle,
          name: el.dataset.productTitle,
          price: '₹' + parseInt(el.dataset.productPrice).toLocaleString('en-IN'),
          qty: el.dataset.quantity
        })
      }
    });

    this.querySelectorAll('.custom-box__card input:checked').forEach((el, index) => {      
      formData.items.push({
        id: el.value,
        quantity: el.dataset.quantity,
        properties: {
          '_ts': timestamp,
          'Box Id': timestamp,
          '_topTitle': document.querySelector('[name="properties[_topTitle]"]').value,
          '_variants': JSON.stringify(variants),
          '_quantity': JSON.stringify(quantity),
          '_message': JSON.stringify(message),
          '_totalPrice': ('₹' + totalPrice.toLocaleString('en-IN')),
          '_productDetails': JSON.stringify(productDetails),
          '_url': window.location.pathname
        }
      });
      formData.items[index].properties[document.querySelector('.custom-box__header .header__subtitle').textContent +' ID'] = timestamp
    });

    formData.items.reverse();

    const addBoxPromise = window.CartFetch
      ? (window.CartFetch.invalidate(), window.CartFetch.post(window.Shopify.routes.root + 'cart/add.js', formData))
      : fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(formData) }).then(r => r.json());

    addBoxPromise
    .then((response) => {
      document.getElementById('recipientInput').value = '';
      document.getElementById('userNameInput').value = '';
      document.getElementById('cmMsgInput').value = '';
      location.href = "/cart";
    })
    .catch((e) => {
      document.body.classList.remove('data-loading');
      alert('ERROR: Please try again after some time.');
    })
    .finally(() => {
      // Cleanup handled
    });
  }
}

customElements.define('custom-box', CustomBox);